import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdCaption01 = (props) => {
  return <LSBdCaption01Wrapper {...props} />;
};

export default LSBdCaption01;

const LSBdCaption01Wrapper = styled(LineSeedKrBd)`
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: -0.3px;

  color: #222222;
`;
